export const __APP_NAME__ = "SHAM";
